import { Button } from '@/components/ui/button';
import { useAppRegion } from '@/hooks/dataHelpers/useCurrentUser';
import { useOfflineAppDownloadUrl } from '@/lib/offline/OfflineAppHelper';
import { DownloadLinear } from '@assessprep/icons/solar';
import { useTranslate } from '@refinedev/core';
import {
  instructionsHeadingClass,
  instructionsListClass,
  sectionClass,
  supportedVersionsClass,
} from './sectionStyles';

export const IpadTab = () => {
  const translate = useTranslate();
  const appRegion = useAppRegion();
  const iosDownloadUrl = useOfflineAppDownloadUrl('ios', appRegion);

  return (
    <div className="space-y-6">
      <div className={sectionClass}>
        <Button asChild data-testid="download-ipad-link">
          <a href={iosDownloadUrl ?? undefined}>
            <DownloadLinear aria-hidden />
            {translate('OfflineApp.download_assessprep_for_ipad')}
          </a>
        </Button>
        <p className={supportedVersionsClass}>
          {translate('OfflineApp.supported_versions_ipados_13_and_above')}
        </p>
      </div>
      <div className={sectionClass}>
        <h3 className={instructionsHeadingClass}>
          {translate('OfflineApp.instructions_to_install_the_app_on_ipad')}:
        </h3>
        <ol className={instructionsListClass}>
          <li>
            {translate('OfflineApp.you_can_take_a_test_by_using_our_assessprep_app_for_ipad')}
          </li>
        </ol>
      </div>
    </div>
  );
};
